import React from "react";

const InvalidPage = ({ image, title, subtitle, actionButton }) => {
  return (
    <div className="">
      <div className="flex flex-col items-center justify-center h-full space-y-4 px-4">
        <img src={image} alt="Invalid Page" className="w-2/3 md:w-1/2 lg:w-1/3 xl:w-1/4" />
        <h1 className="text-[16px] md:text-[18px] lg:text-[20px] font-bold text-center w-full md:w-2/3 lg:w-1/2 xl:w-1/3">
          {title}
        </h1>
        <p className="text-[12px] md:text-[14px] lg:text-[16px] text-center w-full md:w-2/3 lg:w-1/2 xl:w-1/3">{subtitle}</p>
        {actionButton}
      </div>
    </div>
  );
};

export default InvalidPage;
